import React from 'react';
import Footer2Component from '../commons/footer2';
import MenuComponent from '../commons/menu';
import {IndexLink, Link, withRouter} from 'react-router';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

class EWelcomePage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
		
		this.state = {
            menuShow: false,
        }
    }

    mouseClick(event) {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut(event) {
        this.setState({menuShow: false})
    }

    mouseLinkClick(link, event) {
        this.props.router.push(link);
    }

    render() {
        if (isMobile) {
            return (
                <div className="account_box" id={"e-welcome-mobile"}>
                    <div className={"block-001"}>
                        <img className={"img_logo"} src="/static/img/appimg/h_logo.png"/>
                        {isMobile?
                            <MenuComponent is_hide={1}/>
                            :""
                        }
                    </div>
                    <div className={"block-002"}>
                        <div className={"col-xs-12 text-center"}>
                            <span className={"txt-001"}>Versity connects you to the conversations and audiences you need right now.</span>
                            <span className={"txt-002"}>Build your brand, expand your following, and increase the visibility of your company around campus.</span>
                            <span className={"btn"}><Link to="/employers/signup">Claim Your Free Company Page</Link></span>
                            <img src="/static/img/appimg/ewelcome-narrow.png" />
                        </div>
                    </div>
                    <div className={"block-003"}>
                        <div className={"col-xs-12 text-center"}>
                            <span className={"txt-001"}>Find college students on Versity</span>
                            <span className={"txt-002"}>Versity connects brands to college students where they live, study, work and play. Millennials represent the largest and most influential consumer demographic group.</span>
                        </div>
                    </div>
                    <div className={"block-004"}>
                        <div className={"col-xs-12 text-center"}>
                            <span className={"txt-001"}>Expand your reach and grow your platform</span>
                            <span className={"txt-002"}>Promote your brand with customized content to ensure that your target audience is engaging with consistent, relevant information.</span>
                        </div>
                    </div>
                    <div className={"block-005"}>
                        <div className={"col-xs-12 text-center"}>
                            <span className={"txt-001"}>Employer & Talent</span>
                            <span className={"txt-002"}>Put your best face forward and build strategies around workforce development, recruitment, and retention—everything employers need to attract a diverse set of great employees and keep them around longer.</span>
                        </div>
                    </div>
                    <div className={"block-006"}>
                        <div className={"col-xs-12 text-center"}>
                            <span className={"txt-001"}>Get started today</span>
                            <span className={"txt-002"}>Unlock your free company page to Get Started with Company Branding.<br/>We’ve made it easy to get started on Versity.</span>
                            <span className={"btn "}><Link to="/employers/signup">Claim Your Free Company Page</Link></span>
                        </div>
                    </div>
                    <div className={"txtCenter"}>
                        <Footer2Component/>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <div className="account_box" id={"e_welcome"}>
                    <div className={"block-001"}>
                        <img className={"img_logo"} src="/static/img/appimg/h_logo.png"/>
                        <Link className="btn_login" to="/signin">Sign in</Link>
                    </div>
                    <div className={"block-002"}>
                        <div className={"column"}>
                            <span className={"txt-001"}>Versity connects you to the conversations and audiences you need right now.</span>
                            <span className={"txt-002"}>Build your brand, expand your following, and increase the visibility of your company around campus.</span>
                            <span className={"btn-001"}><Link to="/employers/signup">Claim Your Free Company Page</Link></span>
							<img src="/static/img/appimg/ewelcome-narrow.png" />                            
                        </div>
                    </div>
                    <div className={"block-003"}>
                        <div className={"column"}>
                            <span className={"txt-001"}>Find college students on Versity</span>
                            <span className={"txt-002"}>Versity connects brands to college students where they live, study, work and play. Millennials represent the largest and most influential consumer demographic group.</span>
                        </div>
                    </div>
                    <div className={"block-004"}>
                        <div className={"column"}>
                            <span className={"txt-001"}>Expand your reach and grow your platform</span>
                            <span className={"txt-002"}>Promote your brand with customized content to ensure that your target audience is engaging with consistent, relevant information.</span>
                        </div>
                    </div>
                    <div className={"block-005"}>
                        <div className={"column"}>
                            <span className={"txt-001"}>Employer & Talent</span>
                            <span className={"txt-002"}>Put your best face forward and build strategies around workforce development, recruitment, and retention—everything employers need to attract a diverse set of great employees and keep them around longer.</span>
                        </div>
                    </div>
                    <div className={"block-006"}>
                        <div className={"column"}>
                            <span className={"txt-001"}>Get started today</span>
                            <span className={"txt-002"}>Unlock your free company page to Get Started with Company Branding.<br/>We’ve made it easy to get started on Versity.</span>
                            <span className={"btn-001"}><Link to="/employers/signup">Claim Your Free Company Page</Link></span>
                        </div>
                    </div>
                </div>
                <Footer2Component/>
            </div>
        )
    }
}
EWelcomePage.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default (withRouter(EWelcomePage));



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/ewelcome.js
 **/